import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  List,
  IconButton,
  Typography,
} from '@mui/material';
import { MouseEvent, useState } from 'react';
import { logout } from 'renderer/features/auth/state/userSlice';
import { useAppDispatch, useAppSelector } from 'renderer/shared/state/hooks';
import {
  selectIsLoggedIn,
  selectUser,
} from 'renderer/features/auth/state/userSelectors';
import ProfileIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import ViewIcon from '@mui/icons-material/Visibility';
import SocialIcon from '@mui/icons-material/Group';
import BillingIcon from '@mui/icons-material/Receipt';
import LogoutIcon from '@mui/icons-material/Logout';
import UserAvatar from './UserAvatar';

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;
  const user = useAppSelector(selectUser) as {
    firstName: string;
    lastName: string;
    email: string;
    // role: 'user' | 'admin';
    // isEmailVerified: boolean;
    // _id: string;
  };
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
    handleClose();
  };

  const capitalize = (str: string) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <>
      <UserAvatar handleClick={handleClick} />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 'auto', // Set the width to auto to accommodate content
            maxWidth: '100%', // Ensure the menu doesn't exceed the viewport width
            paddingTop: '0px',
          },
        }}
      >
        {isLoggedIn && (
          <MenuItem
            sx={{
              display: 'flex', // Use flexbox for layout
              alignItems: 'center',
              paddingY: 2,
              justifyContent: 'flex-start', // Align items to the start of the menu item
              paddingRight: '24px', // Add some padding to the right
            }}
          >
            <UserAvatar />
            <div
              style={{
                marginLeft: '16px',
                marginRight: 'auto', // This will push the content to the left
                overflow: 'hidden', // Prevent content from overflowing
              }}
            >
              <Typography variant="subtitle1" noWrap>
                {capitalize(user.firstName)} {capitalize(user.lastName)}
              </Typography>
              <Typography variant="body2" noWrap>
                {user.email}
              </Typography>
            </div>
          </MenuItem>
        )}
        {isLoggedIn && <Divider />}
        {isLoggedIn && (
          <MenuItem component={RouterLink} to="/settings">
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </MenuItem>
        )}
        {isLoggedIn && (
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        )}
        {!isLoggedIn && (
          <MenuItem component={RouterLink} to="/login">
            <ListItemText primary="Log In" />
          </MenuItem>
        )}
        {!isLoggedIn && (
          <MenuItem component={RouterLink} to="/register">
            <ListItemText primary="Register" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default UserMenu;
